import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next'

function InputLatLng(props) {
    const [focusInput, setFocusInput] = useState(false);
    const { t } = useTranslation("settings");
    const [detailInput, setDetailInput] = useState({
        Require: false,
        ReadOnly: false,
    })
    const [inputValueLatLng, setInputValueLatLng] = useState({
        Latitude: '',
        Longitude: '',
    });

    useEffect(() => {
        const init = async () => {
            let detail = {
                ...detailInput,
                Require: props.require,
                ReadOnly: props.readonly ? true : false,
            }
            setDetailInput(detail);
        };
        init();
    }, [])

    useEffect(() => {
        setInputValueLatLng({
            Latitude: props.valueLat ? props.valueLat : '',
            Longitude: props.valueLng ? props.valueLng : '',
        });
    }, [props.valueLat, props.valueLng])

    async function onInputText(key, e) {
        const value = e.target.value
        const numbers = new RegExp("^-?[0-9]*[.]?[0-9]*$");
        const check = numbers.test(value);
        if(!check) return

        let detail = {
            ...inputValueLatLng
        }
        detail[key] = value;
        setInputValueLatLng(detail);
        try {
            props.onInputText(detail);
        } catch { }
    }

    return (
        <div className={`w-full  grid grid-cols-3 gap-4 gap-y-2 `}>
                <div className={`h-14 rounded px-2 py-1.5 border border-solid ${focusInput && !detailInput.ReadOnly ? 'border-vekin-primary' : 'border-quartenary'}`}>
                    <div className="flex">
                        <p className="text-secondary text-xs font-normal">
                            {t('site_management.latitude')}
                        </p>
                        {detailInput.Require && <p className="text-secondary text-xs font-normal">&nbsp;*</p>}
                    </div>
                    <input
                        className="w-full text-vekin-primary text-sm focus:outline-0"
                        type={`text`}
                        placeholder={'0.000000'}
                        onFocus={(e) => { setFocusInput(true) }}
                        onBlur={(e) => { setFocusInput(false) }}
                        value={inputValueLatLng.Latitude}
                        readOnly={detailInput.ReadOnly}
                        onInput={(e) => { onInputText('Latitude', e) }}
                    />
                </div>


                <div className={`h-14 rounded px-2 py-1.5 border border-solid ${focusInput && !detailInput.ReadOnly ? 'border-vekin-primary' : 'border-quartenary'}`}>
                    <div className="flex">
                        <p className="text-secondary text-xs font-normal">
                        {t('site_management.longitude')}
                        </p>
                        {detailInput.Require && <p className="text-secondary text-xs font-normal">&nbsp;*</p>}
                    </div>
                    <input
                        className="w-full text-vekin-primary text-sm focus:outline-0"
                        type={`text`}
                        placeholder={'0.000000'}
                        onFocus={(e) => { setFocusInput(true) }}
                        onBlur={(e) => { setFocusInput(false) }}
                        value={inputValueLatLng.Longitude}
                        readOnly={detailInput.ReadOnly}
                        onInput={(e) => { onInputText('Longitude', e) }}
                    />
                </div>
        </div>
    )
}

export default InputLatLng;